<template>
  <el-dialog :visible.sync="isDgShow" :before-close="cancel" :modal="false" :width="playerType == 2 ? '795px' : '675px'" top="0"
    custom-class="dg_title_css" :close-on-click-modal="false" :close-on-press-escape="false" style="z-index: 9999;" :show-close="isTcVideo">
    <div v-if="!showTcVideo" id="rotate" class="lay_css" :class="isRotate">
      <p class="close " v-if="videoType == 'normal'" @click="cancel">退出</p>
      <div class="video_content_wrap">
        <div class="video_box" :key="key || '123'">
          <div v-if="playerType == 1" id="video" style="width:99.8%;height:99.8%;position:relative;">
            <p class="title">
              {{ videoTitle }}
            </p>
            <!-- showOrNot -->
            <div class="pause_icon" :style="{ display: showOrNot }"></div>
            <!-- 满屏时候 控制条 划过出现 实现不太好，处理一下 -->
            <div class="control_bar_modal"></div>
          </div>

          <!-- style="width:99%;height:99%;" -->
          <video v-else-if="playerType == 2" id="player-container-id" preload="auto" width="615" height="480" playsinline
            webkit-playsinline></video>
        </div>

      </div>
      <div v-if="playerType == 2" class="video_list_box colorf">
        <span>视频列表：</span>
        <div v-loading="listLoading" class="list_wrap">
          <div v-for="(item, i) in videoList" :key="item.sort"
            :class="['num_dot', 'pointer', item.highlight ? 'dot_active' : '']" @click="videoItemClick(item, i)">
            {{ i + 1 }}
          </div>
          <!-- <div style="width:20px;height:20px; background:red;margin-right:10px;margin-bottom:10px;"></div>
          <div style="width:20px;height:20px; background:red;margin-right:10px;margin-bottom:10px;"></div>
          <div style="width:20px;height:20px; background:red;margin-right:10px;margin-bottom:10px;"></div> -->
        </div>

      </div>
    </div>
    <div v-if="showTcVideo">
    <video  id="player-container-id" preload="auto" playsinline
            webkit-playsinline></video>
    </div>

       
  </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import screenfull from 'screenfull';
let Aliplayer = window.Aliplayer;
export default {
  props: {
    // 1:阿里播放器 2:腾讯云点播
    playerType: {
      type: String,
      default: '1'
    },
    isTcVideo: {
      type: Boolean,
      default: false
    }

  },
  data() {
    return {
      isDgShow: false,
      videoType: 'normal',
      shareObj: {},
      videoInfo: {},
      url:
        'https://gt-fe.oss-cn-beijing.aliyuncs.com/img/%E5%8D%83%E8%B1%9A%E6%99%BA%E6%85%A7%E5%9B%AD%E5%8C%BA%E5%AE%A3%E4%BC%A0%E7%89%87.mp4',
      timer: null,
      isRotate: '',
      isMobile: '',
      isFullscreen: false,
      showOrNot: 'none',
      pauseListenerExit: false,
      a: '',
      // url1: require('@/assets/portrait.png'),
      CourseID: '',
      LessonID: '',
      videoTitle: '',
      videoList: [],
      videoPlaying: false,
      listLoading: false,
      player: null,
      videoId: '',
      autoPlay: true,
      currentPlayIdx: '',
      key: '',
      tcInfo: {
        w: '615px',
        h: '480px',
      }
    };
  },

  computed: {
    ...mapGetters(['getAccountInfo']),
  },

  mounted() {



  },

  beforeDestroy() {
    this.destroy();
  },
  methods: {
    ...mapActions(['removeVideoInfo']),
    show(obj) {
      this.showTcVideo = this.isTcVideo;
      this.isDgShow = true;
      this.key = obj.key;
      // this.videoInfo = this.$dpcp(this.getOneVideoInfo);
      // 判断是否是视频列表进来直接播放
      console.log(this.isTcVideo,obj);
      if(this.isTcVideo){
      this.getTcVideoAccess({aliVideoId: obj.VideoFileID||obj.AliVideoID, i: 0, autoPlay: true,VideoLocate:  obj.VideoFileID?'Repo':null});    
      }else{
    if (this.playerType != 1) {
        //如果是直播的 查看回放可能是 一个讲次多个视频的 ，这里应该是一个列表
        //  getVideoList
        let data = {
          // VideoCourseID: obj.ClassID,
          // LessonID: obj.ID,

          ClassID: obj.ClassID,
          LessonID: obj.ID,
          PageSize: 100,
          PageIndex: 1 - 1,
        };
        this.listLoading = true;
        this.$api
          .ListVideo(data)
          .then((res) => {
            this.listLoading = false
            this.videoList = res.VideoInfo.map((item) => {
              return {
                ...item,
                highlight: false,
              };
            });
            //如果视频列表有视频，则默认第一个展示，然后设置 自动播放 关掉
            if (this.videoList.length > 0) {
              this.videoList[0].highlight = true;
              this.lookVideo({ aliVideoId: this.videoList[0].AliVideoID, i: 0, autoPlay: true })
            }
          })
          .catch((err) => {
            this.listLoading = false
          });
      } else {
        const params = obj.VideoFileID ? { aliVideoId: obj.VideoFileID, autoPlay: true, "VideoLocate": "Repo", } :
          { aliVideoId: obj.AliVideoID, autoPlay: true }
        console.log(params, 222)
        this.lookVideo(params)
      }
      }
    
    },
    //取消提交
    cancel() {
      console.log(this.player, 111)
      this.isDgShow = false;
      this.showTcVideo = false;
      this.config = {
        title: '',
        tip: ''
      };
      if (this.player) {
        if (this.playerType == 2||this.isTcVideo) {
          this.player.dispose()
          this.player = null;
        } else if (this.playerType == 1) {
          this.player.pause();
          this.player.dispose()
          this.player = null;
        }
      }
      this.$emit('close')
    },
    pageInit() {

    },
    videoItemClick(item, i) {
      // this.key = Math.random();
      this.lookVideo({ aliVideoId: item.AliVideoID, i, autoPlay: true })
    },
    lookVideo(obj) {
      this.autoPlay = obj.autoPlay;
      this.videoId = obj.aliVideoId
      if (this.playerType == 2) {
        this.currentPlayIdx = obj.i;
        this.videoList.forEach((item2, i2) => {
          item2.highlight = false;
          if (i2 == obj.i) {
            item2.highlight = true;
          }
        });
        this.getTcVideoAccess(obj);
      } else {
        this.getAliVideoAccess(obj);
      }

    },
    getAliVideoAccess(obj) {
      //下面这一段 screenfull 全屏相关 暂时用不上了 误删，记忆不好，抽空回头还能看看
      if (this.isMobile) {
        //this.$message('自动横屏')
      } else {
        if (!screenfull.enabled) {
          this.$message({
            message: '浏览器不支持全屏模式',
            type: 'warning',
          });
          //return false;
        } else {
          let issafariBrowser =
            /Safari/.test(navigator.userAgent) &&
            !/Chrome/.test(navigator.userAgent);
          // console.log(this.$utils.IEVersion(), '34', issafariBrowser);
          if (this.$utils.IEVersion() != -1 || issafariBrowser) {
            setTimeout(() => {
              //document.getElementsByClassName('prism-fullscreen-btn')[0].click()
              //console.log(document.getElementsByClassName('prism-fullscreen-btn')[0],'898989')

              //解决 全屏播放时候 IE浏览器多出来的滚动条
              document.body.style.overflow = 'hidden';
            }, 300);
          } else {
            //screenfull.toggle();
          }
        }
      }

      if (this.videoType == 'shareNeedCode') {
        this.videoTitle = `第${this.videoInfo.LessonID || '-'}讲
            ${this.videoInfo.LessonName || '-'}`
        document.title = this.videoTitle;
        let res = {
          PlayAuth: {
            PlayAuth: obj.auth,
          },
        };
        this.initAliVideo(res, obj.aliVideoId, obj.autoPlay);
      } else {
        const data = obj.VideoLocate ? {
        VideoID: obj.aliVideoId,VideoLocate:"Repo"
      } : {
        VideoID: obj.aliVideoId, 
      }
        // GetPreviewAuth
        this.$api.GetPreviewAuth(data).then((res) => {
          console.log(res, 'rreess11')
          // this.videoTitle = `第${this.videoList[obj.i].LessonID || '-' }讲
          // ${ this.videoList[obj.i].LessonName || '-' }`
          this.initAliVideo(res, obj.aliVideoId, obj.autoPlay);
          // document.title = this.videoTitle;
        })
          .catch((err) => {
            // setTimeout(()=>{
            //   this.clockAndGoBack();
            // },200)
          });
      }
    },
    getTcVideoAccess(obj) {
      const data = {
        VideoID: obj.aliVideoId, 
        VideoLocate:obj.VideoLocate
      }
      this.$api.GetPreviewAuth(data).then((res) => {
        console.log(res, 'rreess')
        this.initTcVideo(res, obj.aliVideoId, obj.autoPlay);
        // document.title = this.videoTitle;
      })
        .catch((err) => {
        });
    },

    initAliVideo(res, videoId, autoPlay) {
      let vid = videoId;
      // 下面的定时回传播放时间的，如果player实例存在，则执行不通过那里，所以改用 this.videoId
      this.videoId = videoId;
      if (this.player != null) {
        if (this.timer) {
          clearInterval(this.timer);
          this.timer = null;
        }
        this.player.replayByVidAndPlayAuth(videoId, res.PlayAuth.PlayAuth)
      } else {
        this.player = new Aliplayer(
          {
            id: 'video',
            width: '95%',
            height: '90%',
            videoHeight: 'calc(100% - 0.36rem - 20px - 34px )',
            autoplay: true,
            //支持播放地址播放,此播放优先级最高
            // source : 'https://gt-fe.oss-cn-beijing.aliyuncs.com/img/%E5%8D%83%E8%B1%9A%E6%99%BA%E6%85%A7%E5%9B%AD%E5%8C%BA%E5%AE%A3%E4%BC%A0%E7%89%87.mp4',
            //播放方式二：点播用户推荐
            vid: vid,
            playauth: res.PlayAuth.PlayAuth,
            isLive: false,
            rePlay: false,
            // showBarTime:'3000ms',
            playsinline: true,
            preload: true,
            controlBarVisibility: 'hover',
            useH5Prism: true,
            // "showBarTime":'5000ms',
            // cover: 'http://liveroom-img.oss-cn-qingdao.aliyuncs.com/logo.png',
            // encryptType:1, //当播放私有加密流时需要设置。
            //播放方式三：仅MPS用户使用
            // vid : '1e067a2831b641db90d570b6480fbc40',
            // accId: 'dd',
            // accSecret: 'dd',
            // stsToken: 'dd',
            // domainRegion: 'dd',
            // authInfo: 'dd',
            //播放方式四：使用STS方式播放
            // vid : '1e067a2831b641db90d570b6480fbc40',
            // accessKeyId: 'dd',
            // securityToken: 'dd',
            // accessKeySecret: 'dd',
            //  region:'cn-shanghai',//eu-central-1,ap-southeast-1
          },
          (player) => {
            let videoDom = document.getElementsByTagName('video')[0];
            let pauseIcon = '';
            // console.log(document.getElementsByClassName('.pause'))
            // console.log('播放器创建好了。',videoDom)

            //全屏
            //player.fullscreenService.requestFullScreen();

            // toggole 启停
            this.$utils.addEvent(videoDom, 'click', () => {
              if (this.player.getStatus() == 'playing') {
                this.player.pause();
                //console.log(document.getElementsByClassName('.pause'))//[0].style.display='none';
                //document.getElementsByClassName('.prism-big-play-btn')[0].style.display='block';
              } else {
                this.player.play();
              }
            });
          },
        );
        // if(this.a>0.8 && this.a<0.9 && this.isMobile){
        // player.fullscreenService.requestFullScreen();
        // player.setRotate(90)
        // }

        this.player.on('requestFullScreen', () => {
          // console.log('quanping了11111');

        });



        this.player.on('cancelFullScreen', () => {
          console.log('player event: cancelFullScreen');
          //player.fullscreenService.requestFullScreen();
          // this.clockAndGoBack();
        });

        this.player.on('error', (a, b, c) => {
          console.log('player event: error', a, b, c);
          if (a.paramData.error_code == 4500) {
            localStorage.removeItem('haveAuthCodeInfo');
          }
        });

        this.player.on('ready', () => {
          console.log('ready');
          document.getElementsByClassName('prism-cover')[0].style.backgroundImage = 'none';
          document.getElementsByClassName('prism-big-play-btn')[0].style.display = 'none';
          if (this.autoPlay) {
            this.showOrNot = 'none';

          } else {
            this.showOrNot = 'block';
            document.getElementsByClassName('prism-play-btn')[0].click();
          }

          if (!this.pauseListenerExit) {
            this.pauseListenerExit = true;
            let pauseDom = document.getElementsByClassName('pause_icon')[0];
            // console.log(pauseDom,'dom')
            if (pauseDom) {
              this.$utils.addEvent(pauseDom, 'click', () => {
                if (this.player.getStatus() == 'playing') {
                  this.player.pause();
                } else {
                  this.player.play();
                }
              });
            }
          }


          //player.fullscreenService.requestFullScreen();
          // this.clockAndGoBack();
        });

        this.player.on('play', () => {
          console.log('player event: play')
          this.$nextTick(() => {
            this.showOrNot = 'none';
          })

          if (this.autoPlay) {
            const pauseDom = document.getElementsByClassName('pause_icon')[0];
            if (pauseDom && pauseDom.style && pauseDom.style.display && pauseDom.style.display == 'block') {
              pauseDom.style.display == 'none'
            }
          }
          document.getElementsByClassName('prism-cover')[0].style.cssText = 'display:none!important;backgroundImage:none!important;';

          // if(!this.autoPlay){
          //   this.showOrNot = 'block';
          //   document.getElementsByClassName('prism-play-btn')[0].click();
          //   this.autoPlay = true;

          //   // 去掉 大的概览图
          //   //console.log(document.getElementsByClassName('prism-cover')[0].style)
          //   document.getElementsByClassName('prism-cover')[0].style.cssText='display:none!important;backgroundImage:none!important;';
          //   // this.player.pause();
          //   // this.autoPlay = true;
          // }
        });

        this.player.on('pause', () => {
          console.log('player event: pause')
          this.showOrNot = 'block';
        });

        this.player.on('playing', (a, b, c) => {
          if (!this.timer && this.videoType == 'normal') {
            this.timer = window.setInterval(() => {
              // console.log(this.player.getStatus(),'sssss')
              // this.UpdatePlayInfo(this.videoId, this.player.getCurrentTime());
              // if (this.player.getStatus() == 'playing') {
              //   this.UpdatePlayInfo(this.videoId, this.player.getCurrentTime());
              //   console.log('Playing:' + this.player.getCurrentTime());
              // }
            }, 5000);
          }
        });

        let clear = () => {
          if (this.timer) {
            clearInterval(this.timer);
            this.timer = null;
          }
        };

        this.player.on('ended', () => {
          // if(this.currentPlayIdx==this.videoList.length-1){
          //   this.currentPlayIdx = '';
          //   clear();
          // }else{
          //   this.currentPlayIdx += 1;
          //   let vid = this.videoList[this.currentPlayIdx].AliVideoID
          //   this.videoList.forEach((item,i)=>{
          //     if(i==this.currentPlayIdx){
          //       item.highlight = true;
          //       this.lookVideo({ aliVideoId: item.AliVideoID, i ,autoPlay:true})
          //     }else{
          //       item.highlight = false;
          //     }
          //   })
          // }
        });

        this.player.on('pause', () => {
          console.log('player event: pause 2');
          clear();
        });
      }
    },

    initTcVideo(res, videoId, autoPlay) {
      console.log('执行了吗', this.tcInfo)
      const TCPlayer = window.TCPlayer;
      setTimeout(() => {
        let videoObj = {
          fileID: videoId, //exp:'5285890799710670616', // 请传入需要播放的视频filID 必须
          appID: res.PlayAuth.AppID, //exp:'1400329073', // 请传入点播账号的appID 必须
          psign: res.PlayAuth.PSign, // 参考 Key 防盗链说明
          licenseUrl: 'https://1304435135.trtcube-license.cn/license/v2/1304435135_1/v_cube.license',
        }
        if (this.player) {
          this.player.loadVideoByID(videoObj);
        } else {
            console.log('执行了吗', videoObj)
          this.player = TCPlayer('player-container-id', { // player-container-id 为播放器容器ID，必须与html中一致
            ...videoObj,
            //其他参数请在开发文档中查看
            autoplay: true,
            plugins: {
              ContinuePlay: {
                auto: true // 是否在播放时自动续播
              },
              ProgressMarker: true,
            }
          });
          this.player.ready((res) => { console.log('ready', res) })
          this.player.width('615px')
          this.player.height('480px')
        }
      }, 100)
    },

    //暂时没用  放这里
    whetherRotate() {
      //识别是否为ipad 同时 识别屏宽比，判断是否要 转为横屏模式
      this.isMobile = /Android|webOS|iPhone|BlackBerry/i.test(
        navigator.userAgent,
      );
      let dom = document.getElementById('rotate');
      let width = document.body.clientWidth;
      let height = document.body.clientHeight;
      // console.log(width, height, dom, 'dom');
      let a = width / height;
      this.a = a;
      this.$nextTick(() => {
        this.isRotate = 'rotate90';
        // console.log(dom, 'dom');
        dom.style.height = width + 'px';
        dom.style.width = height + 'px';
        dom.style.position = 'absolute';
        dom.style.left = `calc(50% - ${height / 2}px)`;
        dom.style.top = `calc(50% - ${width / 2}px)`;
      });
      // if(a>0.8 && a<0.9 && this.isMobile){
      //   this.$nextTick(()=>{
      //     this.isRotate = 'rotate90'
      //     console.log(dom,'dom')
      //     dom.style.height = width+'px';
      //     dom.style.width = height+'px';
      //     dom.style.position = 'absolute';
      //     dom.style.left = `calc(50% - ${height/2}px)`;
      //     dom.style.top = `calc(50% - ${width/2}px)`;
      //   })
      // }
    },

    UpdatePlayInfo(videoURL, seconds) {
      console.log(videoURL)
      let data = this.$qs({
        AliVideoURL: videoURL,
        playedtime: seconds,
      });
      this.$api
        .updatePlayInfo(data)
        .then((res) => {
          // console.log('ok');
          //do something or nothing
        })
        .catch((err) => {
          if (err.data.ErrCode == 2) {
            this.player.pause();
          } else {
            this.player.dispose();
            this.player = null;
          }
          // this.$message({
          //   type:'error',
          //   message:err
          // })
        });
    },

    clockAndGoBack() {
      if (screenfull.isFullscreen) {
        screenfull.toggle();
      }
      // this.removeVideoInfo();
      // this.$router.go('-1');
    },
    change() {
      //console.log('change',screenfull)
      this.isFullscreen = screenfull.isFullscreen;
    },
    init() {
      if (screenfull.enabled) {
        screenfull.on('change', this.change);
      }
    },
    destroy() {
      document.body.style.overflow = 'auto';
      if (screenfull.enabled && !this.isFullscreen) {
        screenfull.off('change', this.change);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.lay_css {
  width: 100%;
  height: 500px;
  background: #000000;
  position: relative;
  padding: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.video_content_wrap {
  width: 100%;
  height: 100%;
}

.video_box {
  width: 100%;
  height: 100%;
}

.video_box,
.video_list_box {
  background: #101010;
}

.list_wrap {
  margin-top: 10px;
  display: flex;
  flex-wrap: wrap;
  overflow: auto;
}

.video_list_box {
  @blue: #1092f6;
  width: 120px;
  height: 100%;
  padding-left: 10px;
  padding-top: 80px;

  .num_dot {
    width: 20px;
    height: 20px;
    line-height: 20px;
    text-align: center;
    border: 1px solid white;
    border-radius: 3px;
    margin-right: 10px;
    margin-bottom: 10px;
  }

  .dot_active {
    border-color: @blue;
    color: @blue;
  }

  .teacher {
    margin-bottom: 0.41rem;

    i {
      float: left;
      width: 0.74rem;
      height: 0.74rem;
      margin-right: 0.14rem;
      border-radius: 50%;
    }

    .sex_icon1,
    .sex_icon2 {
      margin-left: 0.06rem;
      display: inline-block;
      width: 0.18rem;
      height: 0.18rem;
      // background: url('../../assets/sex-m.png') left top no-repeat;
      background-size: 100%;
    }

    .sex_icon1 {
      // background: url('../../assets/sex-m.png') left top no-repeat;
      background-size: 100%;
    }

    .sex_icon2 {
      // background: url('../../assets/sex-fm.png') left top no-repeat;
      background-size: 100%;
    }

    p {
      height: 0.37rem;
      line-height: 0.37rem;
      font-size: 0.18rem;
    }
  }

  .list_title {
    margin-bottom: 0.15rem;
    padding-left: 0.06rem;
    border-left: 2px solid @blue;
    height: 0.18rem;

    .title_name {
      line-height: 1;
      float: left;
      margin-top: 0.01rem;
    }

    span:nth-child(2) {
      float: right;
      margin-top: 0.01rem;
      margin-left: 0.04rem;
    }

    .fenxiang {
      float: right;
      // display: inline-block;
      width: 0.18rem;
      height: 0.18rem;

      // background: url('~@/assets/fenxiang2-icon.png') left top no-repeat;
      background-size: 100%;

    }
  }

  .list {
    height: 4.2rem;
    padding: 0.2rem 0;
  }

  .no_data_css {
    line-height: 4.2rem;
    font-size: 0.16rem;
    text-align: center;
  }

}

.close {
  position: absolute;
  right: 23px;
  top: 15px;
  border: 1px solid #bebebe;
  padding: 5px 12px;
  color: white;
  cursor: pointer;
  z-index: 3300;
}

.title {
  position: absolute;
  left: 10px;
  top: 12px;
  padding: 5px 10px;
  color: white;
  // cursor: pointer;
  z-index: 3300;

  // color: lightgray;
  // background: rgba(200,200,200,0.3);
}

.rotate90 {
  transform: rotate(90deg);
}

.pause_icon {
  width: 74px;
  height: 74px;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  margin-left: -38px !important;
  margin-top: -38px !important;
  background-image: url('~@/assets/pause-icon.png') !important;
  background-size: 100%;
  z-index: 1001;
  transition: all 0.3s;
  cursor: pointer;
}
</style>
<style lang="less">
.el-message {
  z-index: 3200 !important;
}

.pause {
  display: none !important;
  position: absolute !important;
  left: 50% !important;
  top: 50% !important;
  margin-left: -32px !important;
  margin-top: -32px !important;
  // background-image: url('../../assets/pause-icon.png') !important;
}

.prism-play-btn {
  margin-left: 20px !important;
  margin-top: 10px !important;
  width: 30px !important;
  height: 30px !important;
}

.prism-fullscreen-btn {
  margin-right: 20px !important;
}

.prism-animation {
  display: none;
}

.prism-controlbar {
  padding-top: 5px;
}

.prism-player .prism-controlbar .prism-controlbar-bg {
  background: rgba(10, 10, 10, 0.45);
}

.control_bar_modal {
  width: 100%;
  height: 40px;
  position: absolute;
  left: 0;
  bottom: 0;
}

:not(:root):fullscreen {
  z-index: 10 !important;
}
</style>
